<template>
	<div>
		<edit-page-gen :options="options" />
	</div>
</template>

<script>
import EditPageGen from './EditPageGen.vue'

const config = {
	options: {
		resource: 'alerts'
	}
}

export default {
	name: 'AlertsEdit',
	components: { EditPageGen },
	data: () => config
}
</script>
